import React, { useState } from "react";
import { Wrapper } from "./PaymentTable.styled";

import { Table, Button, Modal } from "components/common";
import { columns, data } from "./dummnyData";
import AddPaymentModal from "./AddPaymentModal";
import { getUserPermissions } from "utils/text";

const PaymentTable = ({
  formData,
  setFormData,
  callPostApi,
  isLoading,
  setIsLoading,
  payment,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper>
      <Table
        columns={columns}
        header
        dataSource={payment}
        headerTitle="Manage Payments"
        button
        loading={isLoading}
        pagination={false}
        button2={
          getUserPermissions("delete-payment-action") && (
            <Button title="Delete" MinusIcon className="deleteButton" />
          )
        }
        button1={
          getUserPermissions("add-payments-action") && (
            <Button
              title="Add New Payments"
              AddIcon
              className="addButton"
              onClick={() => {
                setIsOpen(true);
              }}
            />
          )
        }
      />
      <Modal
        isOpen={isOpen}
        title="Add New Payment"
        toggleModal={() => {
          setIsOpen(false);
        }}
        className="payment-table-modal"
        onOk={() => {
          callPostApi(formData);
          setIsOpen(false);
        }}
      >
        <AddPaymentModal
          formData={formData}
          setFormData={setFormData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          callPostApi={callPostApi}
        />
      </Modal>
    </Wrapper>
  );
};

export default PaymentTable;
